import { Service } from "./service"

export const SerialNumberListingService = Service


// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/service/index.ts